import { useReduxStorage } from 'src/redux/store';
import _ from 'lodash';

import { clientApi } from 'src/api/clientApi';

const fetchSubscriptionOptions = async () => {
  return await clientApi.fetchSubscriptionOptions();
};

const fetchSubscriptionBuyLinkData = async (plan_key) => {
  return await clientApi.fetchSubscriptionBuyLink(plan_key);
};

const fetchSubscriptionManageLink = async () => {
  const data = await clientApi.fetchSubscriptionManageLink();
  return data?.url;
};

const useSubscription = () => {
  const subscriptionInfoStorage = useReduxStorage('subscription_info');
  const subscriptionData = subscriptionInfoStorage.state.data;

  const subscriptionInfo = subscriptionData?.details || {};
  const preferredTechPartnerName = subscriptionData?.preferred_tech_partner;
  const techPartners = subscriptionData?.tech_partners || [];

  const preferredTechPartner = _.find(techPartners, {
    seller: preferredTechPartnerName,
  });
  const subscriptionTechPartner = _.find(techPartners, {
    seller: subscriptionInfo.seller,
  });

  const hasPreferredTechPartner = !!preferredTechPartner;
  const hasChosenSeller =
    subscriptionInfo &&
    !_.isEmpty(subscriptionInfo) &&
    subscriptionInfo?.seller !== 'demo' &&
    !!subscriptionTechPartner;

  let techPartner;
  if (hasPreferredTechPartner) {
    techPartner = preferredTechPartner;
  } else if (hasChosenSeller) {
    techPartner = subscriptionTechPartner;
  }

  return {
    subscriptionInfo,
    isSubscriptionLocked: subscriptionData?.is_locked || false,
    isSubscriptionLoaded: subscriptionInfoStorage.state?.isLoaded || false,
    isPaymentEnabled: (subscriptionData?.tech_partners || []).length !== 0,
    techPartners,
    // preferredTechPartnerName,
    techPartner,
    reload: subscriptionInfoStorage.loadForced,
    isLoaded: subscriptionInfoStorage.state.isLoaded,
    fetchSubscriptionOptions,
    fetchSubscriptionBuyLinkData,
    fetchSubscriptionManageLink,
  };
};

export default useSubscription;
